import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js_link_list_swiper').forEach(function (element) {
    new Swiper('.js_link_list_swiper[data-key="' + element.dataset.key + '"]', {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper_pagination',
        clickable: true,
      },
      breakpoints: {
        900: {
          spaceBetween: 32,
        },
      },
      navigation: {
        addIcons: false,
      },
    });
  });
});
